import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator"

export function IsValidDate(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isValidDate",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (!value) {
            return true
          }
          const date = new Date(value)
          if (isNaN(date.getTime())) {
            return false
          }
          const year = date.getFullYear()
          return year >= 1900 && year <= 2100
        },
        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyPath] = args.constraints
          return `${args.property} must be less than or equal to ${relatedPropertyPath}`
        },
      },
    })
  }
}
